module.exports = __webpack_public_path__ + "img/q1.baf35a5a.webp";